import * as React from "react";

const FollowUpIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill={props?.fill ?? "#000000"}
  >
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke={props?.stroke ?? "#CCCCCC"}
      stroke-width="0.43200000000000005"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <g
        id="页面-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="User" transform="translate(-384.000000, 0.000000)">
          <g id="user_follow_line" transform="translate(384.000000, 0.000000)">
            <path
              d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z"
              id="MingCute"
              fill-rule="nonzero"
            ></path>
            <path
              d="M16,14 C18.7614,14 21,16.2386 21,19 L21,21 C21,21.5523 20.5523,22 20,22 C19.4477,22 19,21.5523 19,21 L19,19 C19,17.3431 17.6569,16 16,16 L8,16 C6.34315,16 5,17.3431 5,19 L5,21 C5,21.5523 4.55228,22 4,22 C3.44772,22 3,21.5523 3,21 L3,19 C3,16.2386 5.23858,14 8,14 L16,14 Z M21.4141,9.08128 C21.8047,8.69076 22.4378,8.69076 22.8284,9.08128 C23.1888615,9.44176923 23.2165893,10.009022 22.9115834,10.4012974 L22.8284,10.4955 L19.9999,13.3239 C19.6394385,13.6843615 19.0721793,13.7120893 18.6799027,13.4070834 L18.5857,13.3239 L17.1715,11.9097 C16.781,11.5192 16.781,10.886 17.1715,10.4955 C17.5319615,10.1350385 18.0992207,10.1073107 18.4914973,10.4123166 L18.5857,10.4955 L19.2928,11.2026 L21.4141,9.08128 Z M12,2 C14.7614,2 17,4.23858 17,7 C17,9.76142 14.7614,12 12,12 C9.23858,12 7,9.76142 7,7 C7,4.23858 9.23858,2 12,2 Z M12,4 C10.3431,4 9,5.34315 9,7 C9,8.65685 10.3431,10 12,10 C13.6569,10 15,8.65685 15,7 C15,5.34315 13.6569,4 12,4 Z"
              id="形状"
              fill={props?.fill ?? "#000000"}
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default FollowUpIcon;
